import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "app/store";

export const selectObjects = (state: RootState) =>
  state.rootReducer.objectsStore.objects;

export const selectIsLoadingObjects = (state: RootState) =>
  state.rootReducer.objectsStore.isLoadingObjects;

export const selectIsLoadingObjectDetail = (state: RootState) =>
  state.rootReducer.objectsStore.isLoadingObjectDetail;

export const selectObjectFilters = (state: RootState) =>
  state.rootReducer.objectsStore.objectFilters;

export const selectMarkers = (state: RootState) =>
  state.rootReducer.objectsStore.markers;

export const selectSelectedObject = (state: RootState) =>
  state.rootReducer.objectsStore.selectedObject;

export const selectGeozoneObjectsMarkers = (state: RootState) =>
  state.rootReducer.geozonesStore.geozoneObjectsMarkers;

export const selectObjectsSearch = (state: RootState) =>
  state.rootReducer.objectsStore.objectsSearch;

export const selectIsLoadingObjectsSearch = (state: RootState) =>
  state.rootReducer.objectsStore.isLoadingObjectsSearch;

export const selectObjectsState = createSelector(
  selectObjects,
  selectIsLoadingObjects,
  selectIsLoadingObjectDetail,
  selectObjectFilters,
  selectMarkers,
  selectSelectedObject,
  selectGeozoneObjectsMarkers,
  selectObjectsSearch,
  selectIsLoadingObjectsSearch,
  (
    objects,
    isLoadingObjects,
    isLoadingObjectDetail,
    objectFilters,
    markers,
    selectedObject,
    geozoneObjectsMarkers,
    objectsSearch,
    isLoadingObjectsSearch
  ) => ({
    objects,
    isLoadingObjects,
    isLoadingObjectDetail,
    objectFilters,
    markers,
    selectedObject,
    geozoneObjectsMarkers,
    objectsSearch,
    isLoadingObjectsSearch
  })
);
